import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { CreateMycarValetEffect } from './create-mycar-valet.effect';
import { createMycarValetReducer } from './create-mycar-valet.reducer';
import { CREATE_MYCAR_VALET_STORE_NAME, CreateMycarValetState } from './create-mycar-valet.state';

/** Token of the CreateMycarValet reducer */
export const CREATE_MYCAR_VALET_REDUCER_TOKEN = new InjectionToken<ActionReducer<CreateMycarValetState, Action>>(
  'Feature CreateMycarValet Reducer'
);

/** Provide default reducer for CreateMycarValet store */
export function getDefaultCreateMycarValetReducer() {
  return createMycarValetReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(CREATE_MYCAR_VALET_STORE_NAME, CREATE_MYCAR_VALET_REDUCER_TOKEN),
    EffectsModule.forFeature([CreateMycarValetEffect]),
  ],
  providers: [{ provide: CREATE_MYCAR_VALET_REDUCER_TOKEN, useFactory: getDefaultCreateMycarValetReducer }],
})
export class CreateMycarValetStoreModule {
  public static forRoot<T extends CreateMycarValetState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<CreateMycarValetStoreModule> {
    return {
      ngModule: CreateMycarValetStoreModule,
      providers: [{ provide: CREATE_MYCAR_VALET_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
